import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SportIconName } from '../sportsbook/sportsbook.models';

const SPORT_ICON_LIGATURES: Record<SportIconName, string> = {
  soccer: 'sports_soccer',
  tennis: 'sports_tennis',
  basketball: 'sports_basketball',
  'ice-hockey': 'sports_hockey',
  baseball: 'sports_baseball',
  motorsport: 'sports_motorsports',
  darts: 'target',
  football: 'sports_football',
  handball: 'sports_handball',
  rugby: 'sports_rugby',
  'winter-sport': 'downhill_skiing',
  'table-tennis': 'sports_tennis',
  volleyball: 'sports_volleyball',
  generic: 'sports'
};

@Component({
  selector: 'app-sport-icon',
  standalone: true,
  template: `
    <span class="material-symbols-outlined sport-icon" aria-hidden="true">{{ icon() }}</span>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
      }

      .sport-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: var(--sport-icon-size, 1.625rem);
        height: var(--sport-icon-size, 1.625rem);
        font-size: var(--sport-icon-size, 1.625rem);
        line-height: 1;
        font-variation-settings:
          'FILL' 0,
          'wght' 500,
          'GRAD' 0,
          'opsz' 24;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SportIconComponent {
  readonly name = input<SportIconName>('generic');
  protected readonly icon = computed(() => SPORT_ICON_LIGATURES[this.name()]);
}
